// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"466439a8","234":"8f541676"}[chunkId] + ".css";
};